module.exports = __webpack_public_path__ + "static/media/purewatt-2.c7614151.jpg";